<app-prime-loader *ngIf="!(loggedUser$ | async)"></app-prime-loader>
<div class="wrapper-container" *ngIf="loggedUser$ | async">
  <!-- Left Side -->
  <div class="left-side" [class.collapsed]="isMenuCollapsed">
    <!-- Botton colapsar menu -->
    <div
      class="collapse-menu-button"
      (click)="isMenuCollapsed = !isMenuCollapsed"
    >
      <i
        class="fas"
        [class.fa-chevron-right]="isMenuCollapsed"
        [class.fa-chevron-left]="!isMenuCollapsed"
      ></i>
    </div>
    <!-- Top Section -->
    <div class="logo-menu-container">
      <!-- Logo -->
      <figure *ngIf="!isMenuCollapsed" class="logo">
        <img routerLink="/" src="assets/images/logo.svg" alt="SBI" />
      </figure>
      <figure class="env-flag" *ngIf="envFlag">
        <img routerLink="/" [src]="envFlag" alt="Bandera abiente develop" />
      </figure>
      <figure *ngIf="isMenuCollapsed" class="logo-collapsed">
        <img routerLink="/" src="assets/images/logo-collapsed.svg" alt="SBI" />
      </figure>
      <!-- Menu -->
      <ul class="menu">
        <ng-container *ngFor="let section of navigationMenu; let i = index">
          <li
            *ngIf="!!section.activated"
            [class.collapsable]="section.collapsable"
            [class.collapsed]="section.collapsed"
          >
            <span
              (click)="toggleCollapseStatusNavigationSection(i)"
              class="section-title"
            >
              {{ section.title }}
              <i class="fas fa-chevron-up"></i>
            </span>

            <ul class="sub-items">
              <li
                *ngFor="let item of section.navigationItems"
                (click)="navigateTo(item)"
                [class.active]="
                  (currentNavigation$ | async)?.route === item.route ||
                  (currentNavigation$ | async)?.activateRoute === item.route
                "
              >
                <div *ngIf="item.activated">
                  <i class="" [ngClass]="item.icon"></i>
                  {{ item.title }}
                </div>
              </li>
            </ul>
          </li>
        </ng-container>
      </ul>
    </div>

    <!-- Bottom Section -->
    <div class="logged-user">
      <span class="actions">
        <!-- View Profile -->
        <span [routerLink]="viewProfilePath" routerLinkActive="active">
          <i class="pi pi-user" title="Ver Perfil"></i>
        </span>
        <!-- Email -->
        <span class="email" title="{{ (loggedUser$ | async)?.email }}">
          {{ (loggedUser$ | async)?.email }}
        </span>
        <!-- Change Password -->
        <span [routerLink]="changePasswordPath" routerLinkActive="active">
          <i class="pi pi-key" title="Cambiar Contraseña"></i>
        </span>
        <!-- Logout -->
        <span>
          <i
            (click)="onLogoutRequest()"
            class="pi pi-sign-out"
            title="Logout"
          ></i>
        </span>
      </span>
    </div>
  </div>

  <!-- Right Side -->
  <div class="right-side">
    <!-- Loading Spinner -->
    <div *ngIf="loadingModule" class="loader-container">
      <app-prime-loader></app-prime-loader>
    </div>

    <!-- Router Outlet -->
    <router-outlet></router-outlet>
  </div>
</div>
